import '@babel/polyfill';
import Vue from 'vue';
import VConsole from 'vconsole';
import App from './App.vue';
import router from './router';
import store from './store';
import vant from 'vant';

// 初始化 vConsole 调试工具
// const vConsole = new VConsole();
import 'lib-flexible';
import 'vant/lib/index.css';
import './assets/css/style.less';
import mixins from './mixins/global';
import { setBarColor } from './libs/native-app';
import { checkDevice } from './libs/util';
import VueClipboard from 'vue-clipboard2';
import nb from './libs/nativeBridge/index';

// ========== Scheme 回调处理（放最前面，确保尽早注册）==========
// 待处理的 scheme 参数（如果回调来得太早，router 还没初始化）
window._pendingSchemeArgs = null;
window._schemeRouterReady = false;

window.onSchemeCallback = function(args) {
    console.log('收到 App Scheme 回调:', args);
    
    if (!args) return;
    
    // 如果 router 还没准备好，先存起来
    if (!window._schemeRouterReady) {
        console.log('Router 未就绪，暂存 scheme 参数');
        window._pendingSchemeArgs = args;
        return;
    }
    
    // 执行跳转
    window._handleSchemeNavigation(args);
};

window._handleSchemeNavigation = function(args) {
    try {
        const httpUrl = args.replace(/^[a-zA-Z]+:\/\//, 'http://');
        const url = new URL(httpUrl);
        
        let path = url.pathname;
        
        if ((!path || path === '/') && url.hostname) {
            if (url.hostname.includes('.')) {
                // 标准格式：jiuyeduizhang://47.92.114.80/my-center
            } else {
                // 老格式：jiuyeduizhang://my-center
                path = '/' + url.hostname;
            }
        }
        
        let targetPath = path;
        if (url.search) {
            targetPath += url.search;
        }
        
        console.log('Scheme 跳转到:', targetPath);
        
        if (targetPath && targetPath !== '/') {
            router.push(targetPath);
        }
    } catch (e) {
        console.error('Scheme 解析失败:', e);
        // 兜底
        const match = args.match(/^[a-zA-Z]+:\/\/[^/]+(\/.+)$/);
        if (match && match[1]) {
            router.push(match[1]);
        }
    }
};

Vue.use(vant);
Vue.use(VueClipboard);
Vue.mixin(mixins);
Vue.config.productionTip = false;

router.beforeEach(async (to, from, next) => {
  try {
    document.title = to.query.title || to.meta.title;
    // if (to.meta.auth) {
    //   let token = await store.dispatch('postData', {
    //     url: '/user/get-auth-token',
    //     data: {},
    //     need_sign: false
    //   });
    //
    //   if (!token || (!store.state.toHome &&
    //     to.fullPath !== '/base-info' &&
    //     to.fullPath !== '/perfect-info')) {
    //     store.commit('updateToHome', false);
    //     return next('/login');
    //   }
    // }
    next();
  } catch (e) {
    console.error('Router error:', e);
    next();
  }
});

router.afterEach(to => {
  setTimeout(() => {
    setBarColor({ color: to.meta.color || '#ffffff', isLight: to.meta.isLight || 0 });
  }, 50);
});


nb.init(()=>{
  new Vue({ router, store, render: h => h(App) }).$mount('#app');
  
  // 标记 router 已就绪
  window._schemeRouterReady = true;
  
  // 检查是否有待处理的 scheme 参数
  if (window._pendingSchemeArgs) {
    console.log('处理待处理的 scheme 参数:', window._pendingSchemeArgs);
    setTimeout(() => {
      window._handleSchemeNavigation(window._pendingSchemeArgs);
      window._pendingSchemeArgs = null;
    }, 100);
  }
})
